import React from 'react';
import { observer } from 'mobx-react-lite';
import { gameStore } from '../../../store';

export const WheelLightning = observer(() => {
  const { time } = gameStore;
  return (
    <div className={`wheel-light-block ${time || time === 0 ? 'lightning' : ''}`}>
      <div className='wheel-light-item item1'> </div>
      <div className='wheel-light-item item2'> </div>
      <div className='wheel-light-item item3'> </div>
    </div>
  );
});
